import React, { useState, useContext, useEffect } from 'react'
import SecondaryButton from '@/product/components/atoms/SecondaryButton'
import CampaignContext from '@/product/context/campaign/campaignContext'
import CustomDialog from '@/product/components/organisms/Dialog'
import PrimaryButton from '@/product/components/atoms/PrimaryButton'
import CustomTable from '@/product/components/molecules/CustomTable'
import Layout from '@/product/components/templates/Layout'
import { mapData } from '@/product/common/components'
import TemplateManage from './TemplateManage'
import { Button } from '@mui/material'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import './Campaign.css'
import { createSafeMarkup, sanitizeHTML } from '@/product/common/sanitize'

const EmailTemplate = () => {
    const campaignContext = useContext(CampaignContext)

    const {
        getCampaignTemplates,
        all_templates,
        campaignSampleMailTrigger,
        responseStatus,
    } = campaignContext

    const [isPopup, setPopup] = useState({ popup: false, id: 0 })
    const [tableBody, setTableBody] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const [baseId, setBaseId] = useState(0)
    const [totalCount, setTotalCount] = useState({ totalRecords: 0 })
    const [initialValues, setInitialValues] = useState({
        searchterm: '',
        page: 1,
        limit: 20,
        order: '',
        orderby: 'ct.id, desc',
        email: '',
        filters: {
            status: { value: 1, type: 'in', field: 'is_active' },
        },
    })
    const [manage, setManage] = useState({
        popup: false,
        status: 'new',
        id: 0,
        action: '',
    })

    const toggleFullScreenPopup = (popup, status, id) => {
        if (popup) {
            setManage({ popup, status, id })
        } else {
            setManage({ popup, status: 'new', id: 0 })
        }
    }

    const togglePopup = (popup, id) => {
        if (popup) {
            setPopup({ popup, id })
        } else {
            setPopup({ popup, id: 0 })
        }
    }

    const validationArray = Yup.object({
        email: Yup.string().required('Required!'),
    })

    const formik = useFormik({
        initialValues: initialValues,
        validateOnBlur: false,
        enableReinitialize: true,
        validationSchema: validationArray,
        onSubmit: (values) => {
            let value = values
            value.template_id = isPopup.id
            campaignSampleMailTrigger(value, 'CAMPAIGN_MAIL_TRIGGER')
            // setIsLoading(true)
        },
    })

    const DataStore = {
        formik: formik,
        data: [
            {
                label: 'Enter Email address',
                type: 'text',
                placeholder: 'Enter Email address',
                class: 'col-12',
                name: 'email',
            },
        ],
    }

    const onClickEdit = (id, secondaryID, type) => {
        if (type === 'view') {
            togglePopup(true, id)
        } else {
            toggleFullScreenPopup(true, type, id)
        }
    }

    const handlePreview = (id, secondaryID, type) => {
        // No `noopener`/`noreferrer`: this opens a blank, same-origin
        // window populated only with already-sanitized HTML below (never
        // navigated to an external/untrusted URL), so there's no
        // tabnabbing risk to guard against here. `noopener` always makes
        // `window.open()` return `null` per spec, which broke this preview
        // feature entirely.
        const previewWindow = window.open('', 'MsgWindow')
        if (!previewWindow) return

        const previewDocument = previewWindow.document
        const parsed = new DOMParser().parseFromString(
            sanitizeHTML(secondaryID),
            'text/html'
        )
        const head = previewDocument.createElement('head')
        const body = previewDocument.createElement('body')
        Array.from(parsed.head.childNodes).forEach((node) => {
            head.appendChild(previewDocument.importNode(node, true))
        })
        Array.from(parsed.body.childNodes).forEach((node) => {
            body.appendChild(previewDocument.importNode(node, true))
        })
        previewDocument.documentElement.replaceChildren(head, body)
        previewWindow.focus()
    }

    const getMultipleAction = () => {
        let actionPush = []
        actionPush.push(
            {
                buttonType: 'edit',
                clickType: 'edit',
                onclick: onClickEdit,
                tooltipTitle: 'Edit',
            },
            {
                buttonType: 'library_add_check',
                clickType: 'view',
                onclick: onClickEdit,
                tooltipTitle: 'Try Template',
            }
            // {
            //     buttonType: 'remove_red_eye',
            //     clickType: 'preview',
            //     secondaryClickID: 'template',
            //     onclick: handlePreview,
            //     tooltipTitle: 'Preview',
            // },
        )

        return actionPush
    }

    const tableValues = [
        {
            field: 'id',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Id',
            filterable: true,
            filterField: 'ct.id',
        },
        {
            field: 'title',
            type: '',
            firstChild: true,
            sort: true,
            disablePadding: false,
            label: 'Title',
            filterable: true,
            filterField: 'ct.title',
        },
        // {
        //     field: 'subject',
        //     type: '',
        //     firstChild: true,
        //     sort: true,
        //     disablePadding: false,
        //     label: 'Subject',
        // },
        {
            name: 'action',
            field: 'action',
            type: 'button',
            clickID: 'id',
            sort: false,
            firstChild: false,
            disablePadding: false,
            label: 'Action',
            isMultiple: getMultipleAction(),
        },
    ]

    useEffect(() => {
        getCampaignTemplates(initialValues, 'GET_CAMPAIGN_ALL_TEMPLATES')
    }, [])

    useEffect(() => {
        if (all_templates.records && all_templates.records.length) {
            if (all_templates.from === 'GET_CAMPAIGN_ALL_TEMPLATES') {
                let data = []
                all_templates.records.map((spaceDog, index) => {
                    if (spaceDog.type === 'base') {
                        setBaseId(spaceDog.id)
                    } else {
                        data.push(spaceDog)
                    }
                })
                setTableBody(data)
                all_templates.totalRecords = all_templates.totalRecords - 1
                setTotalCount({ totalRecords: all_templates.totalRecords })
            }
        }
        setTimeout(() => {
            setIsLoading(false)
        }, 1000)
    }, [all_templates])

    useEffect(() => {
        if (responseStatus) {
            if (responseStatus.from === 'CAMPAIGN_TEMPLATE_ACTION') {
                toggleFullScreenPopup(false)
                getCampaignTemplates(
                    initialValues,
                    'GET_CAMPAIGN_ALL_TEMPLATES'
                )
            } else if (responseStatus.from === 'CAMPAIGN_MAIL_TRIGGER') {
                togglePopup(false)
                formik.setFieldValue('email', '')
                formik.handleReset()
                // getCampaignTemplates(initialValues, 'GET_CAMPAIGN_ALL_TEMPLATES')
            }
        }
    }, [responseStatus])

    return (
        <>
            <Layout>
                <div className="dashboard listing maillisting">
                    <div className="miscActions d-flex justify-content-start align-items-center flex-wrap mt-4"></div>
                    <div className="body-container">
                        <div className="headingContainer">
                            <h5>Explore Campaigns</h5>
                            <h6>
                                You can add new campaign Email template and
                                broadcast this campaign to all the buyers.
                            </h6>
                        </div>
                        <div className="innerContainerOne">
                            <div className="cardMainContainer">
                                <Button
                                    id="baseBtn"
                                    className="cardBtn"
                                    onClick={() =>
                                        toggleFullScreenPopup(
                                            true,
                                            'base',
                                            baseId
                                        )
                                    }
                                >
                                    <span className="material-icons">
                                        leak_add
                                    </span>
                                    <span>Base Template</span>
                                </Button>
                                <Button
                                    id="baeNewBtn"
                                    className="cardBtn"
                                    onClick={() =>
                                        toggleFullScreenPopup(
                                            true,
                                            'new',
                                            baseId
                                        )
                                    }
                                >
                                    <span className="material-icons">
                                        input
                                    </span>
                                    <span>Add new Template</span>
                                </Button>
                            </div>
                        </div>
                        <div className="headingContainer">
                            <h5>Saved Campaigns</h5>
                        </div>
                        <div>
                            <CustomTable
                                formik={formik.values}
                                tableBody={tableBody}
                                tableValues={tableValues}
                                tableActions={[]}
                                allData={all_templates}
                                isLoading={isLoading}
                                loadingTemplate={'table'}
                                changeTableFunction={getCampaignTemplates}
                                fromVariable={'GET_CAMPAIGN_ALL_TEMPLATES'}
                            />
                        </div>
                        {/* <div className="templateCardCnt">
                            {tableBody.map((data, index) => (
                                <div
                                    className="templateCard"
                                    dangerouslySetInnerHTML={createSafeMarkup(
                                        tableBody[index].template,
                                    )}
                                ></div>
                            ))}
                        </div> */}
                    </div>
                </div>
                <TemplateManage
                    data={manage}
                    function={toggleFullScreenPopup}
                />
            </Layout>

            <CustomDialog
                className="adSlotPopup"
                title="Broadcast"
                open={isPopup.popup}
                openFunction={() => togglePopup(false)}
            >
                <form onSubmit={formik.handleSubmit}>
                    <div className="row">{mapData(DataStore)}</div>
                </form>
                <div className="d-flex align-items-center justify-content-end mt-4">
                    <SecondaryButton
                        label="Cancel"
                        onClick={() => {
                            togglePopup(false)
                            formik.handleReset()
                        }}
                    />
                    <PrimaryButton
                        btnSize="ml-2"
                        label="Send"
                        onClick={() => formik.handleSubmit()}
                    />
                </div>
            </CustomDialog>
        </>
    )
}

export default EmailTemplate
